import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { IoMdClose } from "react-icons/io";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius:'10px',
  boxShadow: 24,
  p: 4,
};

export default function StatementViewModal(props) {
 

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{position:'absolute',top:5,right:5,fontSize:'22px',cursor:'pointer'}} onClick={props.handleClose}>
            <IoMdClose />
          </Box>
          <table>
          {
            props.data&&Object.keys(props.data).length>0?
            Object.entries(props.data).map(([Key,value])=>(
              <tr key={Key}>
                <td>{Key}</td>
                <td> : </td>
                <td>{value}</td>
              </tr>
              
            ))
            :
              <>no data</>
          }
          </table>
        </Box>
      </Modal>
    </div>
  );
}
